import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {ValidationService} from '../../common/validation.service';
import {AuthenticationService} from '../../auth/authentication.service';
import {JwtHelper} from 'angular2-jwt';
import {AppSettings} from '../../app-settings';
import {EventService} from '../../admin/event.service';
import {PackageService} from '../../common/package.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../app.component.css'],
  providers: [ AppSettings, ValidationService, AuthenticationService, JwtHelper, EventService, PackageService ]
})

export class HomeComponent implements OnInit {

  token: any;
  events: any;
  event: any;
  spinner: boolean = false;

  constructor(private auth: AuthenticationService, private router: Router, private eventService: EventService, private packageService: PackageService, private titleService: Title){
  }

  ngOnInit() {
   var userInfo = JSON.parse(localStorage.getItem('userInfo'));
   if(this.auth.loggedIn())
   {
    if(userInfo.type=='Administrator')
    this.router.navigate(['/admin-event-listing']);
    else if(userInfo.type=='Distributor')
    this.router.navigate(['/distributor-profile']);
    else if(userInfo.type=='Supplier')
    this.router.navigate(['/supplier-profile']);
    else if(userInfo.type=='Guest')
    this.router.navigate(['/guest-profile']);
   }
   else
   this.getEventsWithPackages();
   this.titleService.setTitle('Home');
  }

  getEventsWithPackages(){
   this.spinner = true;
   this.eventService.getEventsWithPackages({}).subscribe(
    response => {
     this.spinner = false;
     this.events = response;
     for(var i=0;i<this.events.length;i++)
     if(this.events[i].id==74)
     this.event = this.events[i];
     //console.log(this.event);
     this.event.not_started = parseInt(this.event.not_started);
     this.event.reg_ended = parseInt(this.event.reg_ended);
    },
    error => {
     this.spinner = false;
    }
   );
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/home/home/home.component.ts